import { Container } from 'pixi.js'
import gsap from 'gsap'
import { ANIMATION } from '@/scripts/config/constants'
import type { BulletStyle } from '@/scripts/config/settings'

export function animateLabelShow(labelContainer: Container, labelXPos: number, style: BulletStyle): void {
  gsap.killTweensOf(labelContainer)

  labelContainer.visible = true
  gsap.to(labelContainer, {
    duration: style.SHOW_TWEEN_DURATION,
    x: 0,
    alpha: 1.0,
    delay: ANIMATION.LABEL_ANIMATION_DELAY,
    ease: 'sine.out',
    onComplete: () => {
      labelContainer.visible = true
    },
  })
}

export function animateLabelHide(labelContainer: Container, labelXPos: number, style: BulletStyle): void {
  gsap.killTweensOf(labelContainer)

  gsap.to(labelContainer, {
    duration: style.SHOW_TWEEN_DURATION,
    x: labelXPos,
    alpha: 0,
    ease: 'sine.in',
    onComplete: () => {
      labelContainer.visible = false
    },
  })
}

export function animateBulletShow(bulletContainer: Container): void {
  gsap.killTweensOf(bulletContainer)
  gsap.killTweensOf(bulletContainer.scale)

  bulletContainer.alpha = 0.0
  gsap.to(bulletContainer, {
    duration: 0.3,
    alpha: 1.0,
  })

  bulletContainer.scale.x = 0.4
  bulletContainer.scale.y = 0.4
  gsap.to(bulletContainer.scale, {
    duration: 0.3,
    x: 1.0,
    y: 1.0,
    ease: 'back.out',
  })
}

export function animateBulletHide(bulletContainer: Container, onComplete?: () => void): void {
  gsap.killTweensOf(bulletContainer)
  gsap.killTweensOf(bulletContainer.scale)

  gsap.to(bulletContainer, {
    duration: 0.2,
    alpha: 0.0,
    delay: ANIMATION.LABEL_ANIMATION_DELAY,
  })
  gsap.to(bulletContainer.scale, {
    duration: 0.2,
    x: 0.2,
    y: 0.2,
    delay: ANIMATION.LABEL_ANIMATION_DELAY,
    ease: 'sine.in',
    onComplete,
  })
}
